import buttonStyles from '@styles/scss/buttons/_buttons.module.scss';
import styles from '@styles/scss/common/_bannerCta.module.scss';
import { useTrackingUrl } from 'lib/hooks/useTrackingUrl';
import { Banner } from 'lib/types/item/banner';
export default function BannerCTA({
    banner,
    Ecategory,
    Eaction,
    Elabel1,
    Elabel2,
    gender,
    bannerText,
    currentLang
}: {
    banner: Banner;
    Ecategory: string;
    Eaction: string;
    Elabel1: string;
    Elabel2: string;
    gender: string;
    bannerText: string;
    currentLang: string;
}): JSX.Element {
    
    const signupTracking = useTrackingUrl({
        baseUrl: 'https://rabbits.webcam/',
        tag: 'signup',
        passthru1: gender,
        passthru2: currentLang
    });
    
    const signupTrackingButton = useTrackingUrl({
        baseUrl: 'https://rabbits.webcam/',
        tag: 'signup',
        passthru1: gender,
        passthru2: currentLang
    });
    return (
        <div className={styles.midSectionContent}>
            <div>
                <p>
                    {bannerText ? bannerText : banner.text}
                    {bannerText ? null : (
                        <a
                            ref={signupTracking.linkRef}
                            href={signupTracking.trackingUrl}
                            data-event-category={Ecategory}
                            data-event-action={Eaction}
                            data-event-label={Elabel1}
                            className={styles.bannerLink}>
                            {banner.cta_text}
                        </a>
                    )}
                </p>
            </div>
            <a
                ref={signupTrackingButton.linkRef}
                className={buttonStyles.primaryButton}
                href={signupTrackingButton.trackingUrl}
                data-event-category={Ecategory}
                data-event-action={Eaction}
                data-event-label={Elabel2}>
                <span>{banner.btn_text.toUpperCase()}</span>
            </a>
        </div>
    );
}
